import React, { useState, useEffect } from 'react';
import { collection, doc, query, where, onSnapshot, updateDoc } from 'firebase/firestore';

export function WeddingRentalsManager({ siteData, user, db, navigateTo }) {
    const [linkedBookings, setLinkedBookings] = useState([]);
    const [linkableBookings, setLinkableBookings] = useState([]);
    const [showLinkModal, setShowLinkModal] = useState(false);

    useEffect(() => {
        if (!user || !siteData || !db) return;
        const qLinked = query(collection(db, "bookings"), where("renterId", "==", user.uid), where("weddingId", "==", siteData.id));
        const unsubLinked = onSnapshot(qLinked, snap => setLinkedBookings(snap.docs.map(d => ({id: d.id, ...d.data()}))));
        
        const qUnlinked = query(collection(db, "bookings"), where("renterId", "==", user.uid));
        const unsubUnlinked = onSnapshot(qUnlinked, snap => {
            const all = snap.docs.map(d => ({id: d.id, ...d.data()}));
            setLinkableBookings(all.filter(b => !b.weddingId && !b.eventId && !b.plannerProjectId));
        });

        return () => { unsubLinked(); unsubUnlinked(); };
    }, [user, siteData, db]);

    const handleLinkBooking = async (bookingId) => {
        await updateDoc(doc(db, "bookings", bookingId), { weddingId: siteData.id });
        setShowLinkModal(false);
    };

    return (
        <div className="p-4 md:p-8 h-full overflow-y-auto custom-scrollbar bg-gray-50">
            <div className="max-w-5xl mx-auto space-y-6 animate-fade-in">
                <div className="flex justify-between items-center bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                     <div>
                        <h3 className="text-xl font-bold text-gray-900">Event Rentals</h3>
                        <p className="text-sm text-gray-500">Items booked specifically for your wedding.</p>
                     </div>
                     <div className="flex gap-3">
                         <button onClick={() => setShowLinkModal(true)} className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg font-bold hover:bg-gray-200 transition shadow-sm hidden sm:block">
                             Link Booking
                         </button>
                         <button onClick={() => navigateTo('listings')} className="bg-pink-600 text-white px-4 py-2 rounded-lg font-bold hover:bg-pink-700 shadow-md transition">
                             + Rent Items
                         </button>
                     </div>
                </div>

                {linkedBookings.length > 0 ? (
                    <div className="grid grid-cols-1 gap-4">
                        {linkedBookings.map(booking => (
                            <div key={booking.id} onClick={() => navigateTo('bookingDetail', { booking })} className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex justify-between items-center cursor-pointer hover:border-pink-300 transition">
                                <div>
                                    <p className="font-bold text-gray-900 text-lg">{booking.listingTitle} <span className="text-gray-500 text-sm font-normal">(x{booking.quantity})</span></p>
                                    <p className="text-sm font-medium text-pink-600 mt-1 uppercase tracking-wide">{booking.status}</p>
                                </div>
                                <span className="bg-gray-50 text-gray-600 px-3 py-1.5 rounded-lg font-bold text-sm">View &rarr;</span>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-16 bg-white rounded-xl shadow-sm border-2 border-dashed border-gray-200">
                        <div className="text-4xl mb-3">📦</div>
                        <h3 className="font-bold text-gray-900 text-lg">No rentals linked yet.</h3>
                        <p className="text-gray-500 text-sm mt-1 mb-4">Keep track of all your party rentals right here.</p>
                        <button onClick={() => setShowLinkModal(true)} className="bg-white border border-gray-300 text-gray-700 px-6 py-2 rounded-lg font-bold hover:bg-gray-50 transition shadow-sm">
                             Link an Existing Booking
                        </button>
                    </div>
                )}
            </div>

            {showLinkModal && (
                <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center p-4">
                    <div className="bg-white p-6 rounded-xl shadow-2xl max-w-md w-full">
                        <h3 className="text-xl font-bold mb-4">Link Existing Booking</h3>
                        <div className="space-y-2 max-h-60 overflow-y-auto custom-scrollbar pr-2">
                            {linkableBookings.length > 0 ? linkableBookings.map(b => (
                                <div key={b.id} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg border border-gray-200 hover:border-pink-300 transition">
                                    <div>
                                        <p className="font-bold text-sm text-gray-900">{b.listingTitle}</p>
                                        <p className="text-xs text-gray-500">{b.date}</p>
                                    </div>
                                    <button onClick={() => handleLinkBooking(b.id)} className="bg-green-500 text-white px-3 py-1.5 rounded-md text-xs font-bold hover:bg-green-600 shadow-sm">Link</button>
                                </div>
                            )) : <p className="text-gray-500 text-sm italic">No unlinked bookings found.</p>}
                        </div>
                        <div className="mt-4 pt-4 border-t flex justify-end">
                            <button onClick={() => setShowLinkModal(false)} className="bg-gray-200 text-gray-800 px-5 py-2 rounded-lg text-sm font-bold hover:bg-gray-300">Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}